import React from "react";
import { useNavigate } from "react-router-dom";

const Hero = () => {
  const navigate = useNavigate();

  const goToShop = () => {
    navigate("/shop");
  };

  return (
    <section className="hero-india">
      <div className="hero-content">
        <h1 className="hero-title"><i>Welcome To</i> GGA_ARTS</h1>
        <h4 className="hero-sub">ಸ್ವಾಗತ</h4><br/>
        <p className="hero-tagline">Art Inspired by India’s Soul</p>

        {/* NEW THEMED EXPLORE BUTTON */}
        <button id="explore" onClick={goToShop}>
          Explore Now
        </button>
      </div>
    </section>
  );
};

export default Hero;
